import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ComingSoonSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.3], [0.3, 1]);
  const y = useTransform(scrollYProgress, [0, 0.3], [50, 0]);

  return (
    <section
      ref={ref}
      className="coming-soon-section relative overflow-hidden"
      data-testid="coming-soon-section"
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#111111] to-[#050505]" />

      {/* Content */}
      <motion.div 
        className="relative z-10 text-center px-6"
        style={{ opacity, y }}
      >
        {/* Overline */}
        <motion.span 
          className="font-mono text-xs tracking-[0.3em] text-[#E53935] uppercase block mb-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          The Documentary
        </motion.span>

        {/* Main Title */}
        <motion.h2 
          className="font-heading text-[12vw] sm:text-[10vw] font-light tracking-tighter leading-none text-[#F5F5F0] mb-6"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          data-testid="coming-soon-title"
        >
          COMING SOON
        </motion.h2>

        {/* Subtext */}
        <motion.p 
          className="font-body text-lg sm:text-xl font-light italic text-[#888888] max-w-md mx-auto mb-16"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          A 5840 Films and Agents of Change Production
        </motion.p>

        {/* Divider */}
        <motion.div 
          className="w-px h-16 bg-[#222222] mx-auto mb-8"
          initial={{ scaleY: 0 }}
          whileInView={{ scaleY: 1 }}
          transition={{ delay: 0.8, duration: 0.6 }}
        />

        {/* Credits */}
        <motion.div 
          className="space-y-2"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          <p className="font-mono text-xs tracking-[0.15em] text-[#555555] uppercase">
            A 5840 Films Production
          </p>
          <p className="font-mono text-xs tracking-[0.15em] text-[#444444]">
            © {new Date().getFullYear()} 5840 Films. All Rights Reserved.
          </p>
        </motion.div>

        {/* Contact */}
        <motion.div 
          className="mt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <a 
            href="mailto:info@5840films.com" 
            className="font-mono text-sm tracking-[0.1em] text-[#888888] hover:text-[#F5F5F0] transition-colors"
          >
            info@5840films.com
          </a>
        </motion.div>
      </motion.div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#222222] to-transparent" />
    </section>
  );
};

export default ComingSoonSection;
